import Vue from "vue"
import VueApollo from "vue-apollo"
import { ApolloClient } from "apollo-client"
import { ApolloLink } from "apollo-link"
import store from "@/store"
import { InMemoryCache } from "apollo-cache-inmemory"
import { setContext } from "apollo-link-context"
import { onError } from "apollo-link-error"
import { createUploadLink } from "apollo-upload-client"

Vue.use(VueApollo)
class CleanTypename {
    getLink() {
        return new ApolloLink((operation, forward) => {
            if (operation.variables) {
                operation.variables = this.omitDeep(operation.variables, "__typename")
            }
            return forward(operation)
        })
    }
    omitDeep(obj, key) {
        if (obj instanceof File || obj instanceof Blob) {
            return obj
        }
        const keys = Object.keys(obj)
        const newObj = {}
        keys.forEach(i => {
            if (i !== key) {
                const val = obj[i]
                if (Array.isArray(val)) {
                    newObj[i] = this.omitDeepArrayWalk(val, key)
                } else if (typeof val === "object" && val !== null) {
                    newObj[i] = this.omitDeep(val, key)
                } else {
                    newObj[i] = val
                }
            }
        })
        return newObj
    }
    omitDeepArrayWalk(arr, key) {
        return arr.map(val => {
            if (Array.isArray(val)) return this.omitDeepArrayWalk(val, key)
            else if (typeof val === "object") return this.omitDeep(val, key)
            return val
        })
    }
}
const httpEndpoint =
    process.env.NODE_ENV === "development"
        ? `http://${location.hostname}:4000/graphql`
        : "https://api.topsnap.app/graphql"

export const filesRoot =
    process.env.VUE_APP_FILES_ROOT || httpEndpoint.substr(0, httpEndpoint.indexOf("/graphql"))

Vue.prototype.$filesRoot = filesRoot

const cache = new InMemoryCache()

const authLink = setContext((_, { headers }) => {
    const token = store.getters["user/token"]
    return {
        headers: {
            ...headers,
            authorization: token || "",
            v: process.env.VUE_APP_VERSION,
        },
    }
})
const errorHandler = onError(({ graphQLErrors, networkError }) => {
    store.state.loading = false
    if (graphQLErrors) {
        if (
            graphQLErrors.some(e => {
                return e.extensions.code === "FORBIDDEN"
            })
        ) {
            store.dispatch("user/logout")
            location.reload(true)
            return
        }
        graphQLErrors.map(({ message, locations, path }) =>
            console.error(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
            )
        )
    }
    if (networkError) {
        store.commit("serverError")
        console.error(`[Network error]: ${networkError}`)
    }
})
const cleanTypename = new CleanTypename()
const link = ApolloLink.from([
    cleanTypename.getLink(),
    errorHandler,
    authLink,
    createUploadLink({ uri: httpEndpoint }),
])

const apolloClient = new ApolloClient({
    link,
    cache,
})

const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
        $query: {
            fetchPolicy: "cache-and-network",
            errorPolicy: "all",
        },
    },
    errorHandler(error) {
        store.state.loading = false
        console.error(error)
    },
})

export default apolloProvider
